/*jslint browser: true*/
/*global $, jQuery, alert, window */
window.Modulis || (window.Modulis = {});

$(document).ready(function () {
    $(document).ajaxStart(function() {
        Lemo_Overlay.show();
    });
    $(document).ajaxStop(function() {
        Lemo_Overlay.hide();
    });

    $(window).on('resize', function () {
        var grid = $('.ui-jqgrid-btable:visible');

        if (grid) {
            grid.each(function () {
                var gridId = $(this).attr('id'),
                    gridParentWidth = $('#gbox_' + $(this).attr('id')).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }).trigger('resize');

    $('body').on('click', '.kopirovatDoSchranky', function (e) {
        e.preventDefault();

        var host = 'https://' + window.location.hostname;
        var obsah = '';
        var text = '';

        // ODKAZ
        if ('A' === this.tagName) {
            obsah = this.getAttribute('href');
            text = 'Odkaz byl úspěšně zkopírován do schránky';
        }

        if (obsah.length > 0) {
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(host + obsah).select();
            document.execCommand("copy");
            $temp.remove();

            Lemo_Alert.addSuccess(text);
        }

        return false;
    });

    // Modalni okno potvrzujici smazani
    $('#page-header-buttons, table.ui-jqgrid-btable')
        .off('click', '.dialog-delete')
        .on('click', '.dialog-delete', function(e) {
            e.preventDefault();

            var url = $(this).attr('href');

            Lemo_Modal.setTitle('Potvrzení');
            Lemo_Modal.setContent('<p class="text">Opravdu chcete smazat vybranou položku?</p>');
            Lemo_Modal.addButton('delete', 'Smazat', 'btn btn-primary', function() {
                window.location.href = url
            });
            Lemo_Modal.addButton('cancel', 'Zrušit', 'btn btn-default', function() {
                Lemo_Modal.close();
            });
            Lemo_Modal.build();

            return false;
        });

    $('[data-toggle="tooltip"]').tooltip({
        html: true,
        placement : 'right',
        delay: {
            show: 100,
            hide: 100
        }
    });

    Modulis_Grid.init();
});
